module.exports = __webpack_public_path__ + "img/unlock.fad960fa.svg";